/* Bean Shipper Fresh v3 site layer (18 Oct 2026): behaviour for the homepage
   (sections/index__bs-home-x.liquid, data-bsx="home") and About (sections/page__bs-about-x.liquid,
   data-bsx="about"), plus quick add on search results (sections/search__main.liquid, data-bsx="search", 20 Oct 2026).
   Everything here is an enhancement: every page is complete without it.
   Content only ever moves, never fades (theme rule after a reveal once left a page at opacity 0):
   reveals rest 28px low and fully visible, only once .is-js is on the root. Decorative layers may
   fade. prefers-reduced-motion switches the motion off.
   Quick add: a size and grind sheet reads /products/<handle>.js and adds through a real
   form[data-bs-add], so the theme's ajax cart (assets/bean-shipper.js) adds the line and opens the
   drawer exactly as it does from a PDP. Without this file every quick add is a link to the PDP. */
(function () {
  'use strict';

  var LAND = { cols: 240, rows: 120, step: 1.5, bits: 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAf8AA//wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA////////8AAAAAAAIAAAAAAAAAAAAAAAAAAAAAAP//3/////wAAB/AAceAAAfAAAAAAAAAAAAAAAACPf/8/////+AAAf8AAAAAAAH8AAAAAAAAAAAAAADuCdfw//////AAAHMAAAAAAAAOAAAAAAAAAAAAAAP//v/gOf////AAAAAAAAP4AA//8AAfAAAAAAAAAAfMAv/gAD///+AAAAAAAA8AAH//8AAGAAAAAAAAAA//z+/8AB///8AAAAAAABwDr/////wHgAAAgAGAAAd/48//gB///8AAAAAAABwH//////7/+cABAB//4/8/+/H/4B///4AAAA/8AAHn//////////++wH//////9//H+A///AAAAH//5v//v////////////D/////////B/g//wAAAAH///////////////////P////////+P/Af+AP4AAP7/P///////////////Ag////////vJ+Af4AHgAB/3////////////////+AH///////+CPOAPwAAAAH/P/////////////////AH///////4APwADwAAAAH/P//////////////x/gAA/QH////4APzAAAAAAAH/n//////////////jgAAAHgB////8AP/gAAAAAeAev////////////8AHgAAAYAA/////wX/wAAAAAOB+P////////////wAPgAADAAAf////+f/8AAAAA/A5/////////////wAPAAAAAAAf/////f/+AAAAB3n///////////////AOAAAAAAAD///////+AAAABnv///////////////AMAAAAAAAB///////2AAAAAG///////////////9AAAAAAAAAA//////+HgAAAAH////////////////AAAAAAAAAAf/////+HgAAAAD///////////////7AAAAAAAAAAf//////wAAAAAB///3f5/////////yAAAAAAAAAAf/////7AAAAAAB/7/wfz/////////jgAAAAAAAAAf/////gAAAAAA/4d/gHx/////////HgAAAAAAAAAf/////gAAAAAA/wvf//4////////4EAAAAAAAAAAf////+AAAAAAA/Bjd//5///////3wGAAAAAAAAAAP////8AAAAAAA/AGP//4///////hwEAAAAAAAAAAP////8AAAAAAA+fkE//////////84cAAAAAAAAAAH////8AAAAAAAP/wCC/////////wz8AAAAAAAAAAD////wAAAAAAAf/wAB/////////4PgAAAAAAAAAAA////gAAAAAAA//8cB/////////4MAAAAAAAAAAAA////AAAAAAAB//////////////4AAAAAAAAAAAAAf/7jAAAAAAAB//////z///////8AAAAAAAAAAAAAL/wBgAAAAAAH//////7///////4AAAAAAAAAAAAAF/gBgAAAAAAP////+/8///////wAAAAAAAAAAAAAG/gAAAAAAAAP/////f+wP/////4AAAAAAAAAAAAACfgBgAAAAAAf/////P/8H/////IAAAAAAAAAAAAAAfgS4AAAAAAf/////v/8D////8AAAAAAAAACAAAAAfxwNAAAAAAf/////v/4A/8P+QAAAAAAAAAAAAAAAP7wJwAAAAAf/////n/4A/4P+wAAAAAAAAAAAAAAAD/gAAAAAAAf/////z/gAfgH/AMAAAAAAAAAAAAAAAf8AAAAAAAf/////7+AAfAF/gIAAAAAAAAAAAAAAAD+AAAAAAA///////4AAfAB/gOAAAAAAAAAAAAAAAAeAAAAAAAf//////AAAPAB/gOAAAAAAAAAAAAAAAAMDwAAAAAf/////+MAAPABvgHAAAAAAAAAAAAAAAAGH/wAAAAP//////8AAHABiADAAAAAAAAAAAAAAAAD//4AAAAH//////8AAFgBgADgAAAAAAAAAAAAAAAAP/8AAAAD//////4AABgAwAjAAAAAAAAAAAAAAAAAP//gAAAB/H////4AAAAGYBgAAAAAAAAAAAAAAAAAP//wAAAAAA////wAAAADYHgAAAAAAAAAAAAAAAAAf//4AAAAAA////gAAAAB8PgAAAAAAAAAAAAAAAAAf//4AAAAAA///+AAAAAA8/uQAAAAAAAAAAAAAABA///+AAAAAA///8AAAAAAcfsHAAAAAAAAAAAAAAAA////gAAAAA///8AAAAAAefcDcAAAAAAAAAAAAAAA////+AAAAAf//4AAAAAAODc7/hAAAAAAAAAAAAAA/////gAAAAP//wAAAAAAGAUAf3AAAAAAAAAAAAAA/////gAAAAP//wAAAAAAD4ABP4QAAAAAAAAAAAAAf////gAAAAH//4AAAAAAAfpgPYEAAAAAAAAAAAAAP////AAAAAH//4AAAAAAAADAAODAAAAAAAAAAAAAP////AAAAAH//4AAAAAAAAAEAAAAAAAAAAAAAAAAH///+AAAAAH//4IAAAAAAAAHjAAAAAAAAAAAAAAAH///8AAAAAP//4MAAAAAAAAvjgAAAAAAAAAAAAAAD///8AAAAAP//48AAAAAAAB/zgAAAAAAAAAAAAAAA///8AAAAAP//x4AAAAAAAH//wAADAAAAAAAAAAAAf//8AAAAAP//h4AAAAAAAH//wAAAAAAAAAAAAAAAf//4AAAAAH//B4AAAAAAAf//4AAAAAAAAAAAAAAAf//4AAAAAH//BwAAAAAAD///8AIAAAAAAAAAAAAAf//wAAAAAH//BwAAAAAAD///+AAAAAAAAAAAAAAAf/+AAAAAAD//BwAAAAAAD////AAAAAAAAAAAAAAAf/8AAAAAAD/8AAAAAAAAH////AAAAAAAAAAAAAAA//8AAAAAAD/8AAAAAAAAD////gAAAAAAAAAAAAAA//4AAAAAAB/4AAAAAAAAD////gAAAAAAAAAAAAAA//4AAAAAAB/4AAAAAAAAB////AAAAAAAAAAAAAAA//wAAAAAAA/wAAAAAAAAB/z//AAAAAAAAAAAAAAA//gAAAAAAA/AAAAAAAAAB+A/+AAAAAAAAAAAAAAA/8AAAAAAAAAAAAAAAAAAAgAf+AAQAAAAAAAAAAAB/8AAAAAAAAAAAAAAAAAAAAAH8AAIAAAAAAAAAAAB/8AAAAAAAAAAAAAAAAAAAAAD4AAOAAAAAAAAAAAB/gAAAAAAAAAAAAAAAAAAAAAAAAAMAAAAAAAAAAAB/AAAAAAAAAAAAAAAAAAAAAAA4AAcAAAAAAAAAAAD/AAAAAAAAAAAAAAAAAAAAAAAYAAwAAAAAAAAAAAD+AAAAAAAAAAAAAAAAAAAAAAAAADgAAAAAAAAAAAD4AAAAAAAAAAAAAAAAAAAAAAAAAHAAAAAAAAAAAAD8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAH8AAAAAAAAAAAAAACAAAAAAAAAAAAAAAAAAAAAAAD4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADwIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA8AABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPgAAAAAAAAAAAH4AAH//+H//AAAAAAAAAAAAAAAAGAAAAAAAAAAAD//+D///////+gAAAAAAAAAAAAAA/gAAAAAAAAAH///8f////////+AAAAAAAAAAAAAH/wAAAAD////////9//////////+AAAAAAAAAH5gC/wAAAAP////////////////////AAAAAAJ/0D////wAAAA////////////////////4AAAAD/////////AAAAf////////////////////gAAAP/////////AAAAf/////////////////////kAABD////////wYAPg//////////////////////4AAAQP///////8kw/gf////////////////////+AAAAB//////////AOf//////////////////////gAAv/////////////////////////////////////AA//////////////////////////////////////8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' };
  var KUL = [3.139, 101.687];

  function qsa(el, sel) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); }
  function mm(q) { return !!(window.matchMedia && window.matchMedia(q).matches); }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function money(c) {
    c = Math.round(c || 0);
    var i = Math.floor(c / 100), s = c % 100;
    return 'RM' + String(i).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (s ? '.' + (s < 10 ? '0' : '') + s : '');
  }
  /* Local prices (30 Oct 2026): on Singapore and Hong Kong views snippets/bsx-fx-js sets window.BSFX = { sym, rate }
     (rate = ringgit per local dollar). Checkout charges ringgit, so the local figure is marked with ≈ and the RM
     price stays in the sheet. Everywhere else lmoney() is money(). */
  var FX = window.BSFX && window.BSFX.rate > 0 ? window.BSFX : null;
  function lmoney(c, cup) {
    if (!FX) return money(c);
    var v = (c || 0) / 100 / FX.rate;
    return '\u2248' + FX.sym + (cup ? v.toFixed(2) : String(Math.round(v)));
  }
  function esc(s) {
    return String(s == null ? '' : s).split('&').join('&amp;').split('<').join('&lt;').split('>').join('&gt;').split('"').join('&quot;');
  }
  function grams(label) {
    var v = String(label || '').split(' - ')[0].toLowerCase().replace(/\s+/g, '').replace('×', 'x');
    var n = 1, per = v;
    if (v.indexOf('x') > 0) { n = parseFloat(v.split('x')[0]); per = v.split('x')[1]; }
    var m = /^(\d+(?:\.\d+)?)(kg|g)$/.exec(per || '');
    if (!m || !(n > 0)) return 0;
    return (m[2] === 'kg' ? parseFloat(m[1]) * 1000 : parseFloat(m[1])) * n;
  }
  function bags(label) {
    var v = String(label || '').split(' - ')[0].toLowerCase().replace(/\s+/g, '').replace('×', 'x');
    return v.indexOf('x') > 0 ? (parseFloat(v.split('x')[0]) || 1) : 1;
  }
  function shortLabel(label) { return String(label || '').split(' - ')[0].replace(/\s*x\s*/i, ' × '); }

  var reduce = mm('(prefers-reduced-motion: reduce)');
  var fine = mm('(hover: hover) and (pointer: fine)');
  var hasIO = 'IntersectionObserver' in window;

  /* ---------- one rAF-throttled scroll/resize bus ---------- */
  var scrollFns = [], resizeFns = [], ticking = false;
  function onScroll(f) { scrollFns.push(f); }
  function onResize(f) { resizeFns.push(f); }
  function frame() { ticking = false; for (var i = 0; i < scrollFns.length; i++) scrollFns[i](); }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }, { passive: true });
  var rT;
  window.addEventListener('resize', function () {
    clearTimeout(rT);
    rT = setTimeout(function () { for (var i = 0; i < resizeFns.length; i++) resizeFns[i](); frame(); }, 120);
  });

  function init(root) {
    if (root.__bsx) return;
    root.__bsx = true;
    root.classList.add('is-js');

    /* ---------- reveals ---------- */
    var onReveal = [];
    function reveal(el) {
      if (el.classList.contains('is-in')) return;
      el.classList.add('is-in');
      for (var i = 0; i < onReveal.length; i++) onReveal[i](el);
    }
    var rvs = qsa(root, '.bsx-rv');
    if (reduce || !hasIO) {
      rvs.forEach(reveal);
    } else {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting || e.boundingClientRect.top < 0) { reveal(e.target); io.unobserve(e.target); }
        });
      }, { threshold: 0, rootMargin: '0px 0px -8% 0px' });
      rvs.forEach(function (el) { io.observe(el); });
      var sweepT;
      var sweep = function () {
        var h = window.innerHeight;
        rvs.forEach(function (el) {
          if (el.classList.contains('is-in')) return;
          var r = el.getBoundingClientRect();
          if (r.width && r.top < h && r.bottom > -h) reveal(el);
        });
      };
      window.addEventListener('scroll', function () { clearTimeout(sweepT); sweepT = setTimeout(sweep, 160); }, { passive: true });
      setTimeout(sweep, 1400);
    }
    function replay(container) {
      var els = qsa(container, '.bsx-rv');
      if (reduce) { els.forEach(reveal); return; }
      els.forEach(function (el, i) {
        el.classList.remove('is-in');
        el.style.setProperty('--i', Math.min(i, 8));
      });
      void container.offsetWidth;
      requestAnimationFrame(function () { els.forEach(reveal); });
    }

    /* ---------- count-ups ---------- */
    function fmtNum(v, dec, sep) {
      var s = v.toFixed(dec);
      if (sep) s = s.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
      return s;
    }
    qsa(root, '[data-bsx-count]').forEach(function (el) {
      var to = parseFloat(el.getAttribute('data-bsx-count'));
      if (isNaN(to) || reduce) return;
      var dec = parseInt(el.getAttribute('data-dec') || '0', 10);
      var sep = el.getAttribute('data-sep') || '';
      var from = parseFloat(el.getAttribute('data-from') || '0');
      var done = false;
      function run() {
        if (done) return;
        done = true;
        var t0 = 0, dur = 1500;
        function step(ts) {
          if (!t0) t0 = ts;
          var k = Math.min(1, (ts - t0) / dur), e = 1 - Math.pow(1 - k, 4);
          el.textContent = fmtNum(from + (to - from) * e, dec, sep);
          if (k < 1) requestAnimationFrame(step); else el.textContent = fmtNum(to, dec, sep);
        }
        requestAnimationFrame(step);
      }
      el.textContent = fmtNum(from, dec, sep);
      if (!hasIO) { run(); return; }
      var cio = new IntersectionObserver(function (es) {
        if (es.some(function (e) { return e.isIntersecting; })) { cio.disconnect(); setTimeout(run, 250); }
      }, { threshold: 0.4 });
      cio.observe(el);
    });

    /* ---------- magnetic buttons and tilt (fine pointers only) ---------- */
    if (fine && !reduce) {
      qsa(root, '[data-bsx-magnet]').forEach(function (b) {
        b.addEventListener('pointermove', function (e) {
          var r = b.getBoundingClientRect();
          b.style.setProperty('--mx', ((e.clientX - r.left - r.width / 2) * 0.22).toFixed(1) + 'px');
          b.style.setProperty('--my', ((e.clientY - r.top - r.height / 2) * 0.32).toFixed(1) + 'px');
        });
        b.addEventListener('pointerleave', function () { b.style.setProperty('--mx', '0px'); b.style.setProperty('--my', '0px'); });
      });
      qsa(root, '[data-bsx-tilt]').forEach(function (c) {
        var raf = 0, ev = null;
        function paint() {
          raf = 0; if (!ev) return;
          var r = c.getBoundingClientRect(), x = (ev.clientX - r.left) / r.width, y = (ev.clientY - r.top) / r.height;
          c.style.setProperty('--ry', ((x - 0.5) * 12).toFixed(2) + 'deg');
          c.style.setProperty('--rx', ((0.5 - y) * 9).toFixed(2) + 'deg');
          c.style.setProperty('--gx', (x * 100).toFixed(1) + '%');
          c.style.setProperty('--gy', (y * 100).toFixed(1) + '%');
        }
        c.addEventListener('pointermove', function (e) { ev = e; if (!raf) raf = requestAnimationFrame(paint); });
        c.addEventListener('pointerleave', function () { ev = null; c.style.setProperty('--rx', '0deg'); c.style.setProperty('--ry', '0deg'); });
      });
    }

    /* ---------- generic scroll parallax: [data-bsx-parallax="-.06"] sets --pp ---------- */
    var pars = qsa(root, '[data-bsx-parallax]');
    if (pars.length && !reduce) {
      onScroll(function () {
        var vh = window.innerHeight;
        pars.forEach(function (el) {
          var r = el.getBoundingClientRect();
          if (r.bottom < -200 || r.top > vh + 200) return;
          var f = parseFloat(el.getAttribute('data-bsx-parallax')) || 0;
          el.style.setProperty('--pp', ((r.top + r.height / 2 - vh / 2) * f).toFixed(1) + 'px');
        });
      });
    }

    if (root.getAttribute('data-bsx') === 'home') home(root, reveal, replay, onReveal);
    if (root.getAttribute('data-bsx') === 'about') about(root, onReveal);
    if (root.getAttribute('data-bsx') === 'search') quickAdd(root);
    qsa(root, '[data-bsx-map]').forEach(function (m) { map(root, m); });
    frame();
  }

  /* =====================================================================
     HOME
     ===================================================================== */
  function home(root, reveal, replay, onReveal) {
    /* ---------- hero stage ---------- */
    var stage = root.querySelector('[data-bsx-stage]');
    if (stage) {
      var slides = qsa(stage, '[data-bsx-slide]');
      var dots = qsa(stage, '[data-bsx-goto]');
      var cur = 0, paused = false, hovering = false, focused = false, visible = true;
      function paint() {
        var p = paused || hovering || focused || !visible || document.hidden;
        stage.classList.toggle('is-paused', p);
      }
      function restart() {
        if (reduce || slides.length < 2) return;
        stage.classList.remove('is-auto');
        void stage.offsetWidth;
        stage.classList.add('is-auto');
      }
      function go(n, dir) {
        n = (n + slides.length) % slides.length;
        if (n === cur) { restart(); return; }
        var a = slides[cur], b = slides[n];
        if (!dir) dir = n > cur ? 1 : -1;
        b.style.transition = 'none';
        b.classList.remove('is-on');
        b.classList.toggle('is-past', dir < 0);
        void b.offsetWidth;
        b.style.transition = '';
        a.classList.remove('is-on');
        a.classList.toggle('is-past', dir > 0);
        b.classList.remove('is-past');
        b.classList.add('is-on');
        a.setAttribute('aria-hidden', 'true');
        b.removeAttribute('aria-hidden');
        qsa(a, 'a').forEach(function (l) { l.tabIndex = -1; });
        qsa(b, 'a').forEach(function (l) { l.removeAttribute('tabindex'); });
        dots.forEach(function (d, i) { d.setAttribute('aria-pressed', i === n ? 'true' : 'false'); });
        var tone = b.getAttribute('data-tone');
        if (tone) stage.style.setProperty('--tone', tone);
        cur = n;
        restart();
      }
      dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
      if (slides.length > 1 && !reduce) {
        stage.style.setProperty('--dur', '5.2s');
        stage.addEventListener('animationend', function (e) { if (e.animationName === 'bsxProg' && !stage.classList.contains('is-paused')) go(cur + 1, 1); });
        stage.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { hovering = true; paint(); } });
        stage.addEventListener('pointerleave', function () { hovering = false; paint(); });
        stage.addEventListener('focusin', function () { focused = true; paint(); });
        stage.addEventListener('focusout', function () { focused = false; paint(); });
        document.addEventListener('visibilitychange', paint);
        if (hasIO) new IntersectionObserver(function (es) { visible = es[es.length - 1].isIntersecting; paint(); }, { threshold: 0.15 }).observe(stage);
        var sx = 0, sy = 0;
        stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
        stage.addEventListener('touchend', function (e) {
          var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
          if (Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy) * 1.4) go(cur + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1);
        }, { passive: true });
        restart();
      }
      if (!reduce && fine) {
        var hero = stage.closest('section') || stage;
        var hraf = 0, hev = null;
        hero.addEventListener('pointermove', function (e) {
          hev = e;
          if (hraf) return;
          hraf = requestAnimationFrame(function () {
            hraf = 0; if (!hev) return;
            var r = stage.getBoundingClientRect();
            var x = clamp((hev.clientX - (r.left + r.width / 2)) / r.width, -0.7, 0.7);
            var y = clamp((hev.clientY - (r.top + r.height / 2)) / r.height, -0.7, 0.7);
            stage.style.setProperty('--px', x.toFixed(3));
            stage.style.setProperty('--py', y.toFixed(3));
            var bag = slides[cur] && slides[cur].querySelector('[data-bsx-bagtilt]');
            if (bag) { bag.style.setProperty('--ry', (x * 22).toFixed(2) + 'deg'); bag.style.setProperty('--rx', (-y * 14).toFixed(2) + 'deg'); }
          });
        });
        hero.addEventListener('pointerleave', function () {
          hev = null;
          stage.style.setProperty('--px', '0'); stage.style.setProperty('--py', '0');
          qsa(stage, '[data-bsx-bagtilt]').forEach(function (b) { b.style.setProperty('--ry', '0deg'); b.style.setProperty('--rx', '0deg'); });
        });
      }
      if (!reduce) {
        onScroll(function () {
          var y = Math.min(window.pageYOffset || 0, 1000);
          stage.style.setProperty('--par', (-y * 0.12).toFixed(1) + 'px');
        });
      }
    }

    /* ---------- shop tabs ---------- */
    var tabsEl = root.querySelector('[data-bsx-tabs]');
    if (tabsEl) {
      var tabs = qsa(tabsEl, '[data-bsx-tab]');
      var ink = tabsEl.querySelector('.bshx-tabs__ink');
      var panels = qsa(root, '[data-bsx-panel]');
      var sel = 0;
      function placeInk() {
        var t = tabs[sel]; if (!t || !ink) return;
        ink.style.setProperty('--x', t.offsetLeft + 'px');
        ink.style.setProperty('--w', t.offsetWidth + 'px');
      }
      function select(i, focus) {
        if (i === sel) return;
        sel = i;
        tabs.forEach(function (t, k) {
          t.setAttribute('aria-selected', k === i ? 'true' : 'false');
          t.tabIndex = k === i ? 0 : -1;
        });
        var want = tabs[i].getAttribute('data-bsx-tab');
        panels.forEach(function (p) {
          var on = p.getAttribute('data-bsx-panel') === want;
          if (on) { p.hidden = false; replay(p); var g = p.querySelector('[data-bsx-rail]'); if (g) g.scrollLeft = 0; }
          else p.hidden = true;
        });
        placeInk();
        if (focus) tabs[i].focus();
        var tl = tabs[i].offsetLeft, tw = tabs[i].offsetWidth;
        if (tl < tabsEl.scrollLeft || tl + tw > tabsEl.scrollLeft + tabsEl.clientWidth) tabsEl.scrollTo({ left: Math.max(0, tl - 24), behavior: reduce ? 'auto' : 'smooth' });
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function (e) { e.preventDefault(); select(i); });
        t.addEventListener('keydown', function (e) {
          var k = e.key;
          if (k === 'ArrowRight' || k === 'ArrowLeft' || k === 'Home' || k === 'End') {
            e.preventDefault();
            var n = k === 'Home' ? 0 : k === 'End' ? tabs.length - 1 : (sel + (k === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
            select(n, true);
          } else if (k === ' ' || k === 'Spacebar') {
            e.preventDefault();
            select(i, true);
          }
        });
      });
      placeInk();
      onResize(placeInk);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(placeInk);
    }

    /* ---------- quick-add sheet ---------- */
    quickAdd(root);

    /* ---------- the roast date (scroll story) ---------- */
    var fresh = root.querySelector('[data-bsx-fresh]');
    if (fresh) {
      var track = fresh.querySelector('[data-bsx-track]');
      var scroller = fresh.querySelector('.bshx-fresh__scroll');
      var dayN = fresh.querySelector('[data-bsx-dayn]');
      var dayBox = fresh.querySelector('[data-bsx-day]');
      var phase = fresh.querySelector('[data-bsx-dayphase]');
      var dayN2 = fresh.querySelector('[data-bsx-dayn2]'), phase2 = fresh.querySelector('[data-bsx-dayphase2]');
      var stops = qsa(fresh, '[data-bsx-stop]');
      var sg = root.getAttribute('data-sg') === 'true';
      var lastDay = -1;
      var PH = ['Roasted for your order', 'Dated, sealed, out the door', sg ? 'Couriered to Singapore' : 'On its way to you', sg ? 'Couriered to Singapore' : 'Home before day 7', 'The best window starts', 'The whole window is yours'];
      function setDay(d) {
        d = clamp(Math.round(d), 0, 30);
        if (track) {
          track.style.setProperty('--p', (d / 35).toFixed(4));
          track.classList.toggle('is-win', d >= 7);
        }
        if (d === lastDay) return;
        lastDay = d;
        if (dayN) dayN.textContent = d;
        if (dayN2) dayN2.textContent = d;
        if (dayBox) dayBox.classList.toggle('is-win', d >= 7);
        var st = d === 0 ? 0 : d === 1 ? 1 : d < 7 ? 2 : 3;
        var ph = d === 0 ? PH[0] : d === 1 ? PH[1] : d < 4 ? PH[2] : d < 7 ? PH[3] : d < 12 ? PH[4] : PH[5];
        if (phase) phase.textContent = ph;
        if (phase2) phase2.textContent = ph;
        stops.forEach(function (s, i) { s.classList.toggle('is-on', i === st); });
      }
      if (reduce) { setDay(30); }
      else {
        onScroll(function () {
          var vh = window.innerHeight, p;
          var pinned = scroller && scroller.offsetHeight > vh * 1.2;
          if (pinned) {
            var r = scroller.getBoundingClientRect();
            p = clamp(-r.top / Math.max(1, r.height - vh), 0, 1);
          } else if (track) {
            var t = track.getBoundingClientRect();
            p = clamp((vh * 0.88 - t.top) / (vh * 0.62), 0, 1);
          } else p = 1;
          setDay(p * 30);
        });
      }
    }

    /* ---------- photo film: drifts sideways with the scroll on desktop ---------- */
    var film = root.querySelector('[data-bsx-film]');
    if (film && !reduce) {
      var row = film.querySelector('.bshx-film__row');
      onScroll(function () {
        if (!row) return;
        if (window.innerWidth < 990) { row.style.setProperty('--fx', '0px'); return; }
        var r = film.getBoundingClientRect(), vh = window.innerHeight;
        if (r.bottom < 0 || r.top > vh) return;
        var p = clamp((vh - r.top) / (vh + r.height), 0, 1);
        var max = Math.max(0, row.scrollWidth - film.clientWidth);
        row.style.setProperty('--fx', (-max * p).toFixed(1) + 'px');
      });
    }
    onReveal.push(function (el) { if (el.classList.contains('bshx-frame')) el.classList.add('is-in'); });

    /* ---------- reviews wall ---------- */
    var wall = root.querySelector('[data-bsx-wall]');
    if (wall) {
      var cards = qsa(wall, '.bshx-rcard');
      var marq = false;
      function build() {
        var want = window.innerWidth >= 990 && !reduce && cards.length >= 6;
        if (want === marq) return;
        marq = want;
        if (want) {
          var cols = [0, 1, 2].map(function () { var d = document.createElement('div'); d.className = 'bshx-wcol'; return d; });
          cards.forEach(function (c, i) { c.classList.add('is-in'); cols[i % 3].appendChild(c); });
          cols.forEach(function (col, i) {
            qsa(col, '.bshx-rcard').forEach(function (c) {
              var k = c.cloneNode(true);
              k.setAttribute('aria-hidden', 'true');
              qsa(k, 'a,button').forEach(function (a) { a.tabIndex = -1; });
              col.appendChild(k);
            });
            col.style.setProperty('--dur', (42 + i * 9) + 's');
          });
          wall.textContent = '';
          cols.forEach(function (c) { wall.appendChild(c); });
          wall.classList.add('is-marq');
        } else {
          wall.classList.remove('is-marq');
          wall.textContent = '';
          cards.forEach(function (c) { wall.appendChild(c); });
        }
      }
      build();
      onResize(build);
      if (!reduce) {
        var wraf = 0;
        wall.addEventListener('scroll', function () {
          if (wraf || marq) return;
          wraf = requestAnimationFrame(function () {
            wraf = 0;
            var r = wall.getBoundingClientRect(), cx = r.left + r.width / 2;
            cards.forEach(function (c) {
              var b = c.getBoundingClientRect(), off = (b.left + b.width / 2 - cx) / r.width;
              c.style.transform = 'scale(' + (1 - Math.min(1, Math.abs(off)) * 0.07).toFixed(3) + ') rotate(' + (off * 2).toFixed(2) + 'deg)';
            });
          });
        }, { passive: true });
      }
    }

    /* ---------- spotlight: the giant name drifts ---------- */
    var spot = root.querySelector('[data-bsx-spot]');
    if (spot && !reduce) {
      var word = spot.querySelector('[data-bsx-drift]');
      onScroll(function () {
        var r = spot.getBoundingClientRect(), vh = window.innerHeight;
        if (!word || r.bottom < 0 || r.top > vh) return;
        var p = clamp((vh - r.top) / (vh + r.height), 0, 1);
        word.style.setProperty('--dx', ((0.5 - p) * 520 - 120).toFixed(1) + 'px');
      });
    }

    /* ---------- rhythm dial ---------- */
    var dial = root.querySelector('[data-bsx-dial]');
    if (dial) {
      var cups = parseInt(dial.getAttribute('data-cups'), 10) || 40;
      var wks = qsa(dial, '[data-wk]');
      var wkEl = dial.querySelector('[data-bsx-wk]'), wkU = dial.querySelector('[data-bsx-wku]'), perDay = dial.querySelector('[data-bsx-perday]');
      function perDayTxt(w) {
        var x = cups / (w * 7), n = Math.max(1, Math.round(x * 2) / 2), whole = Math.floor(n), half = n - whole > 0;
        return 'about ' + (whole ? whole : '') + (half ? '½' : '') + ' cup' + (n > 1 ? 's' : '') + ' a day at 15g';
      }
      function pick(b) {
        var w = parseInt(b.getAttribute('data-wk'), 10) || 1;
        wks.forEach(function (o) { o.setAttribute('aria-checked', o === b ? 'true' : 'false'); });
        if (wkEl) wkEl.textContent = w;
        if (wkU) wkU.textContent = w === 1 ? 'week' : 'weeks';
        if (perDay) perDay.textContent = perDayTxt(w);
        dial.style.setProperty('--orb', (3 + w * 2.2).toFixed(1) + 's');
      }
      wks.forEach(function (b) {
        b.addEventListener('click', function () { pick(b); });
        b.addEventListener('keydown', function (e) {
          var i = wks.indexOf(b), n = -1;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = (i + 1) % wks.length;
          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') n = (i - 1 + wks.length) % wks.length;
          if (n >= 0) { e.preventDefault(); pick(wks[n]); wks[n].focus(); }
        });
      });
      var on = wks.filter(function (b) { return b.getAttribute('aria-checked') === 'true'; })[0] || wks[0];
      wks.forEach(function (b) { b.tabIndex = b === on ? 0 : -1; });
      if (on) pick(on);
      wks.forEach(function (b) { b.addEventListener('click', function () { wks.forEach(function (o) { o.tabIndex = o === b ? 0 : -1; }); }); });
    }

    /* ---------- departures board: countdown + split-flap ---------- */
    var tour = root.querySelector('[data-bsx-cutoff]');
    if (tour) {
      var cut = Date.parse(tour.getAttribute('data-bsx-cutoff') || '');
      var cd = tour.querySelector('[data-bsx-countdown]'), cdt = tour.querySelector('[data-bsx-cdtext]'), bst = tour.querySelector('[data-bsx-boardst]');
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        if (isNaN(cut) || !cd) return true;
        var ms = cut - Date.now();
        cd.hidden = false;
        if (ms <= 0) {
          cdt.textContent = "Pre-orders for this month's roaster have closed";
          if (bst) bst.textContent = 'Closed';
          return true;
        }
        var t = Math.floor(ms / 1000), d = Math.floor(t / 86400), h = Math.floor(t % 86400 / 3600), m = Math.floor(t % 3600 / 60), s = t % 60;
        cdt.textContent = 'Pre-orders close in ' + d + 'd ' + pad(h) + 'h ' + pad(m) + 'm ' + pad(s) + 's';
        return false;
      }
      if (!tick()) { var iv = setInterval(function () { if (tick()) clearInterval(iv); }, 1000); }
      var board = tour.querySelector('[data-bsx-board]');
      if (board && !reduce && hasIO) {
        var CH = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
        var flap = function (el, delay) {
          var target = el.getAttribute('data-flap') || el.textContent;
          el.setAttribute('aria-label', target);
          var spans = target.split('').map(function (c) { var sp = document.createElement('span'); sp.className = 'bsx-ch'; sp.setAttribute('aria-hidden', 'true'); sp.textContent = c === ' ' ? ' ' : c; return sp; });
          el.textContent = '';
          spans.forEach(function (sp) { el.appendChild(sp); });
          spans.forEach(function (sp, i) {
            var fin = target.charAt(i); if (!/[A-Z0-9]/.test(fin)) return;
            var n = 5 + Math.floor(Math.random() * 8), k = 0;
            setTimeout(function step() {
              if (k++ < n) { sp.textContent = CH.charAt(Math.floor(Math.random() * CH.length)); sp.classList.add('is-spin'); setTimeout(step, 45); }
              else { sp.textContent = fin; sp.classList.remove('is-spin'); }
            }, delay + i * 24);
          });
        };
        var bio = new IntersectionObserver(function (es) {
          if (!es.some(function (e) { return e.isIntersecting; })) return;
          bio.disconnect();
          qsa(board, '.bshx-board__row').forEach(function (row, r) { qsa(row, '.bshx-flap').forEach(function (el) { flap(el, 200 + r * 160); }); });
        }, { threshold: 0, rootMargin: '0px 0px -12% 0px' });
        bio.observe(board);
      }
    }
  }

  /* =====================================================================
     QUICK ADD
     ===================================================================== */
  function quickAdd(root) {
    var sheet = root.querySelector('[data-bsx-sheet]');
    if (!sheet || !window.fetch) return;
    document.body.appendChild(sheet);
    var body = sheet.querySelector('[data-bsx-sheet-body]');
    var panel = sheet.querySelector('.bsx-sheet__panel');
    var base = root.getAttribute('data-root') || ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/');
    if (base.slice(-1) !== '/') base += '/';
    var shopName = (root.getAttribute('data-shop') || 'Bean Shipper').toLowerCase();
    var shipLine = root.getAttribute('data-ship') || '';
    var cache = {}, opener = null, openSeq = 0;

    function close() {
      if (sheet.hidden) return;
      sheet.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      setTimeout(function () { sheet.hidden = true; body.innerHTML = ''; }, reduce ? 0 : 420);
      if (opener && opener.focus) opener.focus({ preventScroll: true });
    }
    qsa(sheet, '[data-bsx-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (sheet.hidden) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'Tab') {
        var f = qsa(panel, 'button:not([disabled]),a[href],input:not([type=hidden])').filter(function (x) { return x.offsetParent !== null; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    function load(handle) {
      if (cache[handle]) return Promise.resolve(cache[handle]);
      return fetch(base + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
        .then(function (p) { cache[handle] = p; return p; });
    }

    function render(p, ctx) {
      var opts = (p.options || []).map(function (o, i) { return { name: typeof o === 'string' ? o : (o && o.name) || ('Option ' + (i + 1)), i: i }; });
      var vs = p.variants || [];
      function val(v, i) { return (v.options && v.options[i] != null) ? v.options[i] : v['option' + (i + 1)]; }
      var values = opts.map(function (o) {
        var seen = [], out = [];
        vs.forEach(function (v) { var x = val(v, o.i); if (x != null && seen.indexOf(x) < 0) { seen.push(x); out.push(x); } });
        return out;
      });
      var sizeIdx = -1;
      opts.forEach(function (o) { if (sizeIdx < 0 && values[o.i].length && grams(values[o.i][0]) >= 15) sizeIdx = o.i; });
      var start = null;
      vs.forEach(function (v) { if (!start && v.available) start = v; });
      if (!start) start = vs[0];
      if (!start) throw new Error('no variants');
      var state = opts.map(function (o) { return val(start, o.i); });
      var own = !p.vendor || String(p.vendor).toLowerCase() === shopName;

      function find(st, strict) {
        var i, j, ok;
        for (i = 0; i < vs.length; i++) {
          ok = true;
          for (j = 0; j < st.length; j++) if (val(vs[i], j) !== st[j]) { ok = false; break; }
          if (ok && (!strict || vs[i].available)) return vs[i];
        }
        return null;
      }
      function priceFor(i, x) {
        var best = 0;
        vs.forEach(function (v) {
          if (val(v, i) !== x) return;
          var same = true;
          for (var j = 0; j < state.length; j++) if (j !== i && j !== sizeIdx && val(v, j) !== state[j]) same = false;
          if (same && (!best || v.price < best)) best = v.price;
        });
        if (!best) vs.forEach(function (v) { if (val(v, i) === x && (!best || v.price < best)) best = v.price; });
        return best;
      }
      function anyAvail(i, x) { return vs.some(function (v) { return v.available && val(v, i) === x; }); }

      var img = (p.featured_image || (p.images && p.images[0]) || '');
      if (img && img.indexOf('//') === 0) img = 'https:' + img;
      var isCut = /\.png(\?|$)/i.test(img);
      var imgSrc = img ? img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=720' : '';
      var nameId = 'bsx-sheet-t';
      var h = '<div class="bsx-qs" style="--tone:' + esc(ctx.tone || '#EE9A2E') + '">';
      h += '<div class="bsx-qs__media' + (isCut ? '' : ' is-photo') + '">' + (imgSrc ? '<img src="' + esc(imgSrc) + '" alt="" width="720" height="900">' : '') + '</div>';
      h += '<div class="bsx-qs__info">';
      if (ctx.meta) h += '<p class="bsx-qs__k">' + esc(ctx.meta) + '</p>';
      h += '<h3 class="bsx-qs__t" id="' + nameId + '">' + esc(p.title) + '</h3>';
      if (ctx.notes) h += '<p class="bsx-qs__notes">' + esc(ctx.notes) + '</p>';
      h += '<form class="bsx-qs__form" action="' + esc(base + 'cart/add') + '" method="post" enctype="multipart/form-data" data-bs-add>';
      h += '<input type="hidden" name="id" value="' + start.id + '"><input type="hidden" name="quantity" value="1">';
      opts.forEach(function (o) {
        var isSize = o.i === sizeIdx;
        var label = isSize ? 'Size' : (/grind|prep/i.test(o.name) ? 'Grind' : o.name);
        if (values[o.i].length < 2 && !isSize) return;
        h += '<fieldset class="bsx-qs__opt"><legend>' + esc(label) + '</legend><div class="bsx-qs__chips' + (isSize ? ' bsx-qs__chips--size' : '') + '" role="radiogroup" aria-label="' + esc(label) + '">';
        values[o.i].forEach(function (x) {
          var dis = !anyAvail(o.i, x);
          if (isSize) {
            h += '<button type="button" class="bsx-chip" role="radio" aria-checked="false" data-i="' + o.i + '" data-v="' + esc(x) + '"' + (dis ? ' disabled' : '') + '><b>' + esc(shortLabel(x)) + '</b><span class="bsx-chip__p" data-p></span><small data-c></small></button>';
          } else {
            h += '<button type="button" class="bsx-chip bsx-chip--pill" role="radio" aria-checked="false" data-i="' + o.i + '" data-v="' + esc(x) + '"' + (dis ? ' disabled' : '') + '>' + esc(x) + '</button>';
          }
        });
        h += '</div></fieldset>';
      });
      h += '<p class="bsx-qs__pc" data-pc></p>';
      h += '<button type="submit" class="bsx-btn bsx-qs__add" data-bs-pdp-add><span data-lbl>Add to bag</span></button>';
      h += '<p class="bsx-qs__micro">' + (own ? 'Roasted to order · ships within 24 hours of roasting · ' : '') + esc(shipLine) + '.' + (own ? ' Not right? Free replacement.' : '') + '</p>';
      h += '<p class="bsx-qs__err" data-err hidden></p>';
      h += '<a class="bsx-link bsx-qs__more" href="' + esc(ctx.url || (base + 'products/' + p.handle)) + '">See the full details <span aria-hidden="true">→</span></a>';
      h += '</form></div></div>';
      body.innerHTML = h;

      var form = body.querySelector('form');
      var idIn = form.querySelector('input[name=id]');
      var chips = qsa(form, '.bsx-chip');
      var pcEl = form.querySelector('[data-pc]');
      var lbl = form.querySelector('[data-lbl]');
      var add = form.querySelector('.bsx-qs__add');
      var first0 = sizeIdx >= 0 ? values[sizeIdx][0] : null;
      var g0 = first0 ? grams(first0) : 0;

      function paint() {
        var v = find(state, true) || find(state, false);
        if (!v) return;
        state = opts.map(function (o) { return val(v, o.i); });
        idIn.value = v.id;
        chips.forEach(function (c) { c.setAttribute('aria-checked', state[+c.getAttribute('data-i')] === c.getAttribute('data-v') ? 'true' : 'false'); });
        if (sizeIdx >= 0) {
          var p0 = priceFor(sizeIdx, first0);
          chips.forEach(function (c) {
            if (+c.getAttribute('data-i') !== sizeIdx) return;
            var x = c.getAttribute('data-v'), pr = priceFor(sizeIdx, x), g = grams(x), cupsN = Math.floor(g / 15);
            var pe = c.querySelector('[data-p]'), ce = c.querySelector('[data-c]');
            if (pe) pe.textContent = pr ? lmoney(pr) : '';
            if (ce) ce.textContent = cupsN ? lmoney(Math.round(pr / cupsN), true) + '/cup' : '';
            var old = c.querySelector('.bsx-chip__save'); if (old) old.remove();
            var nb = bags(x);
            if (nb > 1 && g0 && Math.abs(g / nb - g0) < 1 && p0) {
              var save = Math.floor((p0 * nb - pr) / 100);
              if (save > 0) { var sv = document.createElement('span'); sv.className = 'bsx-chip__save'; sv.textContent = FX ? 'Save \u2248' + FX.sym + Math.max(1, Math.round(save / FX.rate)) : 'Save RM' + save; c.appendChild(sv); }
            }
          });
          var gs = grams(state[sizeIdx]), cn = Math.floor(gs / 15);
          pcEl.innerHTML = cn ? '<span>' + cn + ' cups at 15g</span><span><b>' + lmoney(Math.round(v.price / cn), true) + '</b> a cup' + (FX ? ' · ' + money(v.price) + ' at checkout' : '') + '</span>' : '';
        } else pcEl.innerHTML = '';
        add.disabled = !v.available;
        lbl.textContent = v.available ? 'Add to bag · ' + lmoney(v.price) : 'Sold out';
      }
      chips.forEach(function (c) {
        c.addEventListener('click', function () {
          if (c.disabled) return;
          state[+c.getAttribute('data-i')] = c.getAttribute('data-v');
          var exact = find(state, true);
          if (!exact) {
            var i = +c.getAttribute('data-i'), x = c.getAttribute('data-v');
            var alt = null;
            vs.forEach(function (v) { if (!alt && v.available && val(v, i) === x) alt = v; });
            if (alt) state = opts.map(function (o) { return val(alt, o.i); });
          }
          paint();
        });
      });
      form.addEventListener('submit', function () {
        if (add.disabled) return;
        setTimeout(close, 60);
      });
      paint();
      var fc = form.querySelector('.bsx-chip[aria-checked="true"]') || add;
      if (fc && fc.focus) fc.focus({ preventScroll: true });
    }

    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-bsx-qa]');
      if (!t || !root.contains(t)) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
      e.preventDefault();
      var handle = t.getAttribute('data-bsx-qa');
      opener = t;
      var card = t.closest('.bsx-card,[data-bsx-spot],.bshx-bcard');
      var ctx = { url: t.getAttribute('href'), tone: '', meta: '', notes: '' };
      if (card) {
        ctx.tone = (card.style.getPropertyValue('--tone') || '').trim();
        var m = card.querySelector('.bsx-card__meta,.bshx-bcard__m'); if (m) ctx.meta = m.textContent.trim();
        var n = card.querySelector('.bsx-card__notes,.bshx-spot__notes'); if (n) ctx.notes = qsa(n, 'li').map(function (li) { return li.textContent.trim(); }).join(' · ');
      }
      var seq = ++openSeq;
      if (sheet.parentNode !== document.body || sheet.nextElementSibling) document.body.appendChild(sheet);
      body.innerHTML = '<div class="bsx-qs__load" aria-busy="true"><span style="height:180px;border-radius:22px"></span><span style="width:60%"></span><span style="width:80%"></span><span style="width:40%"></span></div>';
      sheet.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(function () { requestAnimationFrame(function () { sheet.classList.add('is-open'); panel.focus({ preventScroll: true }); }); });
      load(handle).then(function (p) { if (seq === openSeq) render(p, ctx); }).catch(function () {
        if (seq !== openSeq) return;
        body.innerHTML = '<div class="bsx-qs__info"><h3 class="bsx-qs__t" id="bsx-sheet-t">One more step</h3><p class="bsx-qs__notes">We couldn\'t load the options here. Pick your size and grind on the coffee\'s own page.</p><a class="bsx-btn" href="' + esc(ctx.url) + '"><span>Open the coffee</span></a></div>';
      });
    });
  }

  /* =====================================================================
     ABOUT
     ===================================================================== */
  function about(root, onReveal) {
    var tl = root.querySelector('[data-bsx-timeline]');
    if (tl) {
      var body = tl.querySelector('.bsax-tl__body');
      var line = tl.querySelector('.bsax-tl__line');
      var chs = qsa(tl, '.bsax-ch');
      var yearEl = tl.querySelector('[data-bsx-tlyear]');
      var curY = '';
      onScroll(function () {
        if (!body) return;
        var vh = window.innerHeight, r = body.getBoundingClientRect();
        var p = clamp((vh * 0.6 - r.top) / Math.max(1, r.height), 0, 1);
        if (line) line.style.setProperty('--tp', reduce ? 1 : p.toFixed(4));
        var now = -1;
        chs.forEach(function (c, i) { var b = c.getBoundingClientRect(); if (b.top < vh * 0.62) now = i; });
        chs.forEach(function (c, i) { c.classList.toggle('is-now', i === now); c.classList.toggle('is-past', i < now); });
        var y = now >= 0 ? chs[now].getAttribute('data-year') : chs.length ? chs[0].getAttribute('data-year') : '';
        if (yearEl && y && y !== curY) {
          curY = y;
          yearEl.textContent = y;
          if (!reduce) { yearEl.classList.remove('is-tick'); void yearEl.offsetWidth; yearEl.classList.add('is-tick'); }
        }
      });
    }
    var steps = root.querySelector('[data-bsx-steps]');
    if (steps) {
      if (reduce || !hasIO) steps.classList.add('is-in');
      else {
        var sio = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) { steps.classList.add('is-in'); sio.disconnect(); } }, { threshold: 0.2 });
        sio.observe(steps);
      }
    }
    if (!reduce && fine) {
      var vis = root.querySelector('.bsax-hero__vis');
      var hero = root.querySelector('.bsax-hero');
      if (vis && hero) {
        hero.addEventListener('pointermove', function (e) {
          var r = vis.getBoundingClientRect();
          var x = clamp((e.clientX - (r.left + r.width / 2)) / r.width, -0.7, 0.7), y = clamp((e.clientY - (r.top + r.height / 2)) / r.height, -0.7, 0.7);
          vis.style.setProperty('--px', x.toFixed(3)); vis.style.setProperty('--py', y.toFixed(3));
          var bag = vis.querySelector('[data-bsx-bagtilt]');
          if (bag) { bag.style.setProperty('--ry', (x * 18).toFixed(2) + 'deg'); bag.style.setProperty('--rx', (-y * 10).toFixed(2) + 'deg'); }
        });
        hero.addEventListener('pointerleave', function () { vis.style.setProperty('--px', '0'); vis.style.setProperty('--py', '0'); });
      }
    }
  }

  /* =====================================================================
     ORIGINS MAP (canvas): dots from the land bitmap, a pin per listed country, great-circle arcs to KL
     ===================================================================== */
  function map(root, box) {
    var cv = box.querySelector('canvas');
    if (!cv || !cv.getContext || !window.atob) return;
    var list = root.querySelector('[data-bsx-olist]');
    var items = list ? qsa(list, 'li[data-lat]') : [];
    var pins = items.map(function (li) { return { lat: parseFloat(li.getAttribute('data-lat')), lng: parseFloat(li.getAttribute('data-lng')), name: li.getAttribute('data-name') || '', li: li }; }).filter(function (p) { return !isNaN(p.lat) && !isNaN(p.lng); });
    if (!pins.length) return;
    var raw = atob(LAND.bits), bits = new Uint8Array(raw.length);
    for (var b = 0; b < raw.length; b++) bits[b] = raw.charCodeAt(b);
    /* Flight arcs are drawn on the flat map (a lifted curve from each origin to KL), not as great
       circles: a great circle from Central America to KL crosses the Pacific and would leave the map
       at one edge and come back at the other. */
    var lats = pins.map(function (p) { return p.lat; }).concat([KUL[0]]), lngs = pins.map(function (p) { return p.lng; }).concat([KUL[1]]);
    var lngMin = Math.min.apply(null, lngs) - 16, lngMax = Math.max.apply(null, lngs) + 16;
    var latMid = (Math.min.apply(null, lats) + Math.max.apply(null, lats)) / 2;
    var spanLat = Math.max(80, Math.max.apply(null, lats) - Math.min.apply(null, lats) + 50);
    var cLng = (lngMin + lngMax) / 2, spanLng = lngMax - lngMin;
    var ctx = cv.getContext('2d'), W = 0, H = 0, CW = 0, dpr = 1, scale = 1, baseC = null, ox = 0, panMax = 0;
    var visible = !hasIO, start = 0, raf = 0, hot = -1;
    function proj(lat, lng) { return [CW / 2 + (lng - cLng) / scale, H / 2 - (lat - latMid) / scale]; }
    function layout() {
      var r = box.getBoundingClientRect();
      if (!r.width || !r.height) return false;
      dpr = Math.min(2, window.devicePixelRatio || 1);
      W = r.width; H = r.height;
      scale = Math.max(spanLng / W, spanLat / H);
      if (W < 760) scale = spanLat / H;
      CW = Math.max(W, spanLng / scale);
      panMax = Math.max(0, CW - W);
      cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
      cv.style.width = W + 'px'; cv.style.height = H + 'px';
      var k0 = proj(KUL[0], KUL[1]);
      pins.forEach(function (p) {
        p.xy = proj(p.lat, p.lng);
        var dx = k0[0] - p.xy[0], dy = k0[1] - p.xy[1], dist = Math.hypot(dx, dy) || 1;
        var lift = Math.min(H * 0.42, dist * 0.24);
        var mx = (p.xy[0] + k0[0]) / 2, my = (p.xy[1] + k0[1]) / 2;
        var nx = -dy / dist, ny = dx / dist;
        if (ny > 0) { nx = -nx; ny = -ny; }
        var cx = mx + nx * lift, cy = my + ny * lift;
        var N = Math.max(10, Math.round(dist / 6));
        p.pts = [];
        for (var i = 0; i <= N; i++) {
          var f = i / N, a = (1 - f) * (1 - f), b2 = 2 * (1 - f) * f, c = f * f;
          p.pts.push([a * p.xy[0] + b2 * cx + c * k0[0], a * p.xy[1] + b2 * cy + c * k0[1]]);
        }
      });
      baseC = document.createElement('canvas');
      baseC.width = Math.round(CW * dpr); baseC.height = Math.round(H * dpr);
      var g = baseC.getContext('2d');
      g.scale(dpr, dpr);
      var kul = proj(KUL[0], KUL[1]);
      var b1 = proj(23.5, 0)[1], b2 = proj(-23.5, 0)[1];
      var grad = g.createLinearGradient(0, b1, 0, b2);
      grad.addColorStop(0, 'rgba(255,154,163,0)'); grad.addColorStop(0.5, 'rgba(255,154,163,.07)'); grad.addColorStop(1, 'rgba(255,154,163,0)');
      g.fillStyle = grad; g.fillRect(0, b1, CW, b2 - b1);
      g.strokeStyle = 'rgba(255,154,163,.16)'; g.setLineDash([3, 6]); g.lineWidth = 1;
      [b1, b2].forEach(function (yy) { g.beginPath(); g.moveTo(0, yy); g.lineTo(CW, yy); g.stroke(); });
      g.setLineDash([]);
      var cell = LAND.step / scale, rad = Math.max(0.7, Math.min(1.8, cell * 0.34)), diag = Math.max(CW, H);
      for (var j = 0; j < LAND.rows; j++) {
        var lat = 90 - LAND.step / 2 - j * LAND.step;
        for (var k = 0; k < LAND.cols; k++) {
          var n = j * LAND.cols + k;
          if (!(bits[n >> 3] & (0x80 >> (n & 7)))) continue;
          var lng = -180 + LAND.step / 2 + k * LAND.step;
          while (lng - cLng > 180) lng -= 360;
          while (lng - cLng < -180) lng += 360;
          var q = proj(lat, lng);
          if (q[0] < -4 || q[0] > CW + 4 || q[1] < -4 || q[1] > H + 4) continue;
          var dk = Math.hypot(q[0] - kul[0], q[1] - kul[1]) / diag;
          var a = (W < 760 ? 0.2 : 0.14) + 0.2 * Math.max(0, 1 - dk * 1.6);
          g.fillStyle = 'rgba(244,240,238,' + a.toFixed(3) + ')';
          g.beginPath(); g.arc(q[0], q[1], rad, 0, 6.2832); g.fill();
        }
      }
      return true;
    }
    var SEG = 1150, GAP = 260;
    function draw(now) {
      if (!start) start = now;
      var t = now - start;
      if (panMax > 0) {
        var target = hot >= 0 ? clamp(pins[hot].xy[0] - W / 2, 0, panMax) : (0.5 - 0.5 * Math.cos(t / 9000)) * panMax;
        ox += (target - ox) * 0.06;
      } else ox = 0;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.clearRect(0, 0, W, H);
      var sw = Math.min(W * dpr, baseC.width - ox * dpr);
      if (sw > 0) ctx.drawImage(baseC, ox * dpr, 0, sw, baseC.height, 0, 0, sw / dpr, H);
      ctx.save();
      ctx.translate(-ox, 0);
      var kul = proj(KUL[0], KUL[1]);
      pins.forEach(function (p, i) {
        var t0 = i * (SEG * 0.55 + GAP), k = reduce ? 1 : clamp((t - t0) / SEG, 0, 1);
        var e = 1 - Math.pow(1 - k, 3), n = Math.max(2, Math.round(e * p.pts.length));
        var isHot = hot === i;
        if (k > 0) {
          ctx.beginPath(); ctx.moveTo(p.pts[0][0], p.pts[0][1]);
          for (var s = 1; s < n; s++) ctx.lineTo(p.pts[s][0], p.pts[s][1]);
          ctx.strokeStyle = isHot ? 'rgba(255,120,130,.95)' : 'rgba(255,90,103,' + (k < 1 ? 0.75 : 0.32) + ')';
          ctx.lineWidth = isHot ? 2.2 : 1.3;
          ctx.stroke();
          if (k < 1) {
            var hd = p.pts[n - 1];
            ctx.beginPath(); ctx.arc(hd[0], hd[1], 2.6, 0, 6.2832); ctx.fillStyle = '#fff'; ctx.fill();
          } else if (!reduce) {
            var lp = ((t - t0 - SEG) / (2600 + i * 180)) % 1, idx = Math.floor(lp * (p.pts.length - 1)), pk = p.pts[idx];
            ctx.beginPath(); ctx.arc(pk[0], pk[1], isHot ? 2.8 : 1.9, 0, 6.2832); ctx.fillStyle = 'rgba(255,214,218,.95)'; ctx.fill();
          }
        }
        var pulse = reduce ? 0 : ((t + i * 400) % 2400) / 2400;
        if (k >= 1 && pulse > 0) { ctx.beginPath(); ctx.arc(p.xy[0], p.xy[1], 4 + pulse * 14, 0, 6.2832); ctx.strokeStyle = 'rgba(244,240,238,' + (0.5 * (1 - pulse)).toFixed(3) + ')'; ctx.lineWidth = 1; ctx.stroke(); }
        ctx.beginPath(); ctx.arc(p.xy[0], p.xy[1], isHot ? 5 : 3.6, 0, 6.2832); ctx.fillStyle = isHot ? '#FF8590' : '#F4F0EE'; ctx.fill();
        if (W >= 760 || isHot) {
          ctx.font = '500 10px ui-monospace, SFMono-Regular, Menlo, Consolas, monospace';
          ctx.fillStyle = isHot ? '#fff' : 'rgba(244,240,238,.7)';
          var lx = p.xy[0] + 8, ly = p.xy[1] - 8;
          if (p.name === 'Malaysia') { lx = p.xy[0] - ctx.measureText(p.name.toUpperCase()).width - 10; ly = p.xy[1] + 16; }
          ctx.fillText(p.name.toUpperCase(), lx, ly);
        }
      });
      var kp = reduce ? 0 : (t % 2000) / 2000;
      ctx.beginPath(); ctx.arc(kul[0], kul[1], 6 + kp * 22, 0, 6.2832); ctx.strokeStyle = 'rgba(232,57,74,' + (0.7 * (1 - kp)).toFixed(3) + ')'; ctx.lineWidth = 1.6; ctx.stroke();
      ctx.beginPath(); ctx.arc(kul[0], kul[1], 6, 0, 6.2832); ctx.fillStyle = '#E8394A'; ctx.fill();
      ctx.beginPath(); ctx.arc(kul[0], kul[1], 11, 0, 6.2832); ctx.strokeStyle = 'rgba(232,57,74,.5)'; ctx.lineWidth = 1; ctx.stroke();
      ctx.font = '600 10px ui-monospace, SFMono-Regular, Menlo, Consolas, monospace';
      ctx.fillStyle = '#FF97A0';
      ctx.fillText('KUALA LUMPUR', kul[0] + 14, kul[1] - 12);
      ctx.restore();
      if (visible && !reduce) raf = requestAnimationFrame(draw); else raf = 0;
    }
    function kick() { if (!raf && layout()) raf = requestAnimationFrame(draw); }
    if (hasIO) {
      new IntersectionObserver(function (es) {
        visible = es[es.length - 1].isIntersecting;
        if (visible && !raf) { if (!baseC && !layout()) return; raf = requestAnimationFrame(draw); }
      }, { threshold: 0, rootMargin: '120px 0px' }).observe(box);
    } else kick();
    onResize(function () { if (layout() && !raf) raf = requestAnimationFrame(draw); });
    pins.forEach(function (p, i) {
      p.li.addEventListener('mouseenter', function () { hot = i; p.li.classList.add('is-hot'); if (reduce) kick(); });
      p.li.addEventListener('mouseleave', function () { hot = -1; p.li.classList.remove('is-hot'); if (reduce) kick(); });
      p.li.addEventListener('focus', function () { hot = i; p.li.classList.add('is-hot'); if (reduce) kick(); });
      p.li.addEventListener('blur', function () { hot = -1; p.li.classList.remove('is-hot'); if (reduce) kick(); });
    });
  }

  function boot() { qsa(document, '[data-bsx]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
